export default "__VITE_ASSET__a6c3299b__"